import { screen, colors } from 'components/styles/variables';
import MonthlyPayment from 'components/Shared/MonthlyPayment';

export interface CardInfoProps {
  year: number;
  make: string;
  model: string;
  trim: string;
  mileage: string;
  city: string;
  state: string;
  price: string;
  monthlyPayment?: number;
  isAcceptingOffers: boolean;
}

const CardInfo = ({
  year,
  make,
  model,
  trim,
  mileage,
  city,
  state,
  price,
  monthlyPayment,
  isAcceptingOffers,
}: CardInfoProps): JSX.Element => {
  const acceptingOffersClass = isAcceptingOffers ? 'accepting-offers' : '';

  return (
    <div className="card-info">
      <div className="primary-details">
        <h3 className="title">{`${year} ${make} ${model} ${trim}`}</h3>
        <div className="mileage">{mileage}</div>
        <div className="location">{`${city}, ${state}`}</div>
      </div>
      <div className="price-container">
        <div className={`price ${acceptingOffersClass}`}>{price}</div>
        {/* For some reason moving this check into a variable assignment causes TS to think monthlyPayment might still be undefiend */}
        {!isAcceptingOffers && monthlyPayment && <MonthlyPayment monthlyPayment={monthlyPayment} />}
      </div>
      <style jsx>{`
        .card-info {
          display: flex;
          justify-content: space-between;
        }

        @media (min-width: ${screen.smMin}) {
          .card-info {
            flex-grow: 1;
            padding-top: 4px;
          }
        }

        .primary-details {
          overflow: wrap;
        }

        @media (min-width: ${screen.smMin}) {
          .primary-details {
            max-width: 75%;
          }
        }

        .title {
          margin: 0;
          padding: 0;
          margin-bottom: 3px;
          letter-spacing: 0.2px;
          font-weight: 600;
          font-size: 18px;
        }

        @media (min-width: ${screen.smMin}) {
          .title {
            margin-bottom: 6px;
          }
        }

        .mileage {
          margin-bottom: 2px;
          letter-spacing: 0.2px;
          font-weight: 300;
          font-size: 16px;
        }

        @media (min-width: ${screen.smMin}) {
          .mileage {
            margin-bottom: 6px;
          }
        }

        .location {
          color: ${colors.G3};
          letter-spacing: 0.2px;
          font-size: 16px;
          font-weight: 300;
        }

        .price {
          max-width: 137px;
          margin-bottom: 2px;
          text-align: right;
          letter-spacing: 0.2px;
          font-size: 18px;
          font-weight: 600;
        }

        @media (min-width: ${screen.smMin}) {
          .price {
            margin-bottom: 2px;
            font-size: 20px;
          }
        }

        .accepting-offers {
          font-size: 16px;
          font-weight: 400;
          color: ${colors.G3};
          max-width: 69px;
          text-align: right;
        }
      `}</style>
    </div>
  );
};

export default CardInfo;
